import { Nullable, Option } from '../../../types/commonTypes';
import { MaterialType } from './../../../types/materialTypes';

export enum VolumeSchema {
  ALKU_PVM = 'Alkupäivä',
  PAATTYMIS_PVM = 'Päättymispäivä',
  PAIVAMAARA = 'Päivämäärä',
  TYYPPI = 'Tyyppi',
  MATERIAALI = 'Materiaali',
  NIMIKE = 'Nimike',
  PAINO = 'Paino',
  KAPPALEMAARA = 'Kappalemäärä',
  KAPPALETYYPPI = 'Kappaletyyppi',
  LAHTOPISTE = 'Lähtöpiste',
  KOHDEPISTE = 'Kohdepiste',
  KUNTATOIMIJA = 'Kuntatoimija',
  KUNTA = 'Kunta',
  HYOTYKAYTTOMENETELMA = 'Hyötykäyttömenetelmä',
  KAUSI = 'Kausi',
  VUOSI = 'Vuosi',
  AJONEUVO = 'Ajoneuvo',
  KERAYSTYYPPI = 'Keräystyyppi',
  KULJETUSLIIKE = 'Kuljetusliike',
  SELITE = 'Selite',
}

export interface Accordion {
  materialType: MaterialType;
  accordionSummary: { icon: JSX.Element; text: string };
  form: {
    formProps: {
      fields: any[];
      remove: any;
      columns: {
        base: any;
        rows: any;
      };
      volumeForm: any;
      removeRowBtnColor: string;
    };
    appendFn: () => void;
  };
  onSubmit: () => void;
  onClear: () => void;
  isSaving: boolean;
}

interface WoodInputs<T> {
  [VolumeSchema.KAUSI]: Nullable<Option>;
  [VolumeSchema.VUOSI]: Nullable<number>;
  rows: Array<T>;
}

export type RecyclingInputs = WoodInputs<{
  [VolumeSchema.KOHDEPISTE]: Nullable<Option>;
  [VolumeSchema.PAINO]: Nullable<number>;
  [VolumeSchema.HYOTYKAYTTOMENETELMA]: Nullable<Option>;
}>;

export type RepairingInputs = WoodInputs<{
  [VolumeSchema.KOHDEPISTE]: Nullable<Option>;
  [VolumeSchema.KAPPALETYYPPI]: Nullable<Option>;
  [VolumeSchema.KAPPALEMAARA]: Nullable<number>;
  [VolumeSchema.PAINO]: Nullable<number>;
}>;

export const isRepairingInput = (
  input: RepairingInputs | RecyclingInputs,
): input is RepairingInputs => {
  return (input as RepairingInputs).rows.some((row) => row.Kappaletyyppi !== undefined);
};

export enum PalletType {
  EUR = 'EUR-lava',
  FIN = 'FIN-lava',
  TEHO = 'Teho-lava',
  CABLE = 'Kaapelikelat',
  OTHER = 'Muu lava',
}

// Kappalepaino
export interface ItemWeight {
  name: PalletType;
  weight?: number;
}

export enum Term {
  FIRST = '1.1. - 30.6.',
  SECOND = '1.7. - 31.12.',
}

export enum VolumeType {
  ACCEPTED = 'Hyväksytty',
  REJECTED = 'Hylätty',
}
